export const introduce = {
  text: '该指标统计了token前1%地址持有所占的供应百分比，可以判断出token的持有集中度',
  height: 1200,
};
